var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-8"},[_c('client-form',{attrs:{"client":_vm.client,"title":"Nuevo cliente"},on:{"submit":_vm.addClient}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }